app.directive("tinymceEditor", [
    "$window", "$http", "$rootScope",
    function ($window, $http, $rootScope) {
        var editor = $window.tinymce || null;
        if (!editor) {
            return;
        }
        var DEFAULT_OPTIONS = {
            selector: "[tinymce-editor]",
            min_height: 500,
            branding: false,
            language: "fr_FR",
            fontsize_formats: '8pt 10pt 11pt 12pt 14pt 18pt 24pt 36pt',
            font_formats: "Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Andale Mono=andale mono,times; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
            plugins: [
                "advlist autolink lists link image print preview hr anchor pagebreak",
                "searchreplace wordcount visualblocks visualchars code fullscreen",
                "media save table contextmenu directionality",
                "emoticons template textcolor colorpicker textpattern imagetools"
            ],
            toolbar1:
                "undo redo | fontsizeselect | fontselect | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image |",
            toolbar2: "print preview | forecolor backcolor",
            menubar: "tools",
        };
        var UPLOAD_OPTIONS = {
            images_upload_credentials: true,
            automatic_uploads: true,
            relative_urls: false,
            remove_script_host: false,
            image_prepend_url: $window.location.href
        };

        return {
            restrict: "A",
            scope: {
                options: "=",
                uploadUrl: "@",
                entityId: "@",
                uploadData: "@",
                imagePrependUrl: "@"
            },
            link: function (scope) {
                var options = Object.assign(DEFAULT_OPTIONS, scope.options || {});

                if (scope.uploadUrl) {
                    options = Object.assign(UPLOAD_OPTIONS, options);

                    if (scope.imagePrependUrl) {
                        options.image_prepend_url = scope.imagePrependUrl;
                    }

                    options.images_upload_handler = function (blobInfo, success) {
                        $rootScope.$broadcast("tinymce.upload.pending");
                        var fd = new FormData();
                        fd.append(
                            "attachment",
                            blobInfo.blob(),
                            blobInfo.filename()
                        );
                        fd.append("entity_id", scope.entityId);
                        if (scope.uploadData && scope.uploadData.length) {
                            var data = JSON.parse(scope.uploadData);
                            for (var i in data) {
                                if (data.hasOwnProperty(i)) {
                                    fd.append(i, data[i]);
                                }
                            }
                        }
                        $http({
                            url: scope.uploadUrl,
                            method: "POST",
                            data: fd,
                            headers: {"Content-Type": undefined}
                        })
                            .then(function (res) {
                                $rootScope.$broadcast("tinymce.upload.done", {
                                    success: true,
                                    message: "Fichier uploadé avec succès"
                                });
                                success(res.data.url);
                            })
                            .catch(function (err) {
                                $rootScope.$broadcast("tinymce.upload.done", {
                                    success: false,
                                    message: err.data
                                });
                                success("http://placehold.it/350x150");
                            });
                    };
                }
                if (options.min_height && options.min_height === "auto") {
                    options.min_height = Math.round($window.innerHeight / 1.5);
                }

                editor.init(options);

                $rootScope.$on('tinymce.notification', function (e, notification) {
                    editor.activeEditor.notificationManager.open(notification);
                });
            }
        };
    }
]);
